/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Showasonboarding2Inputs */

const de__field_showasonboarding2 = /** @type {(inputs: _Field_Showasonboarding2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Einarbeitung anzeigen`)
};

/**

* @param {_Field_Showasonboarding2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_showasonboarding2 = /** @type {((inputs?: _Field_Showasonboarding2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Showasonboarding2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_showasonboarding2(inputs)
});
export { _field_showasonboarding2 as "_field_showAsOnboarding" }